import Swiper, { Navigation, Pagination } from 'swiper'
Swiper.use([ Navigation, Pagination ])

class RatingSlider {
  
  constructor (el) {
    this.el = el
    this.slider = null
    this.sliderContainer = el.querySelector('.js-rating-slider-container')
    this.initDefault()
  }

  initDefault () {
    this.initSlider()
  }

  initSlider () {
    this.slider = new Swiper( this.sliderContainer, {
      spaceBetween: 32,
      slidesPerView: 2,
      observeParents: true,
      observer: true,
      breakpoints: {
        0: {
          spaceBetween: 16,
          slidesPerView: 1
        },
        768: {
          spaceBetween: 16,
          slidesPerView: 2
        },
        1024: {
          spaceBetween: 32,
          slidesPerView: 2
        }
      },
      navigation: {
        prevEl: '.js-slider-control-prev',
        nextEl: '.js-slider-control-next'
      },
      pagination: {
        el: '.js-slider-control-pagination',
        clickable: true
      }
    })
  }

}

document.addEventListener('DOMContentLoaded', e => {
  const el = document.querySelector('.js-rating-slider')
  if ( el ) {
    window.MainCities = new RatingSlider(el)
  }
})